import { Button } from "../../ui/Button";

export interface SaveControlsProps {
    onSave?: () => void;
    onCancel?: () => void;
    onReset?: () => void;
    saveText?: string;
    cancelText?: string;
}

const SaveControls = (props: SaveControlsProps) => {
    return (
        <div className="w-full flex flex-col gap-3">
            {
                props.onSave && <Button className="w-full" onClick={props.onSave}>{props.saveText || 'Salvar alterações'}</Button>
            }
            {
                props.onCancel && <Button className="w-full" variant={'outline'} onClick={props.onCancel}>{props.cancelText || 'Cancelar alterações'}</Button>
            }
        </div>
    )
};

export default SaveControls;